import React, { FunctionComponent, memo } from 'react'
import { useQueries } from '../../../../../utils/hooks/useQueries'
import ProjectFiltersMobile from './ProjectFiltersMobile/ProjectFiltersMobile'
import ProjectFiltersDesktop from './ProjectFiltersDesktop/ProjectFiltersDesktop'
import { ProjectFiltersProps } from './props'

const ProjectFilters: FunctionComponent<ProjectFiltersProps> = props => {
    const {isMobile} = useQueries()

    return isMobile? <ProjectFiltersMobile {...props}/>: <ProjectFiltersDesktop {...props}/>
}

export default memo(ProjectFilters)